var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.routeName !== 'main')?_c('Header'):_vm._e(),_c('router-view'),(this.routeName !== 'main')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }